import { Button } from "@onengine/component-library";
import type { ChangeStatus } from "@/store/form-builder/useAssistantStore";
import styles from "./Assistant.module.scss";

interface ChangeCardProps {
  summary: string;
  status: ChangeStatus;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ChangeCard({ summary, status, onConfirm, onCancel }: ChangeCardProps) {
  return (
    <section className={styles.proposalCard} aria-label="Change to the proposal">
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Change to the proposal</span>
        {status === "confirmed" && <span className={styles.statusChip}>Confirmed</span>}
        {status === "cancelled" && <span className={styles.statusChip}>Cancelled</span>}
      </div>
      <span className={styles.cardBody}>{summary}</span>
      {status === "pending" && (
        <div className={styles.cardActions}>
          <Button variant="primary" size="small" onClick={onConfirm}>
            Confirm change
          </Button>
          <Button variant="tertiary" size="small" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      )}
    </section>
  );
}
